import React, { useState } from "react";
import {
  Box,
  Button,
  Container,
  TextField,
  Typography,
  Stepper,
  Step,
  StepLabel,
  Grid2,
} from "@mui/material";
import LoggedInLayout from "../../layout/LoggedInLayout";
import PaymentStepOne from "./PaymentStepOne";
import { MuiOtpInput } from "mui-one-time-password-input";
import OTPVerification from "./paymentStepTwoOtp";
import CommonButtonActionButton from "../common/CommonButtonActionButton";
import { useNavigate } from 'react-router-dom';

const ThankYou = ({handleBackToHome}) => {
  
  return (

    <Box display={'flex'} sx={{ margin: "40px 20%" }} flexDirection={'column'} rowGap={2} alignItems={'center'} textAlign={'center'} >
      <img src="/assets/images/background/success-tick.svg"></img>
      <Typography color="#20D29D" fontSize={'40px'} fontWeight={'600'} gutterBottom>
        Payment Successful!
      </Typography>
      <Typography fontSize={'18px'} fontWeight={'400'}>
        Thank you for your payment. An automated payment receipt will be sent to your registered email.
      </Typography>
      <CommonButtonActionButton onClick={handleBackToHome}>Back to Home</CommonButtonActionButton>
    </Box>
  );
};

// Main Component
const PaymentPage = () => {
  const [currentStep, setCurrentStep] = useState(0);
  const [formData, setFormData] = useState({

    otp: "",
  });
  const navigate = useNavigate();

  const steps = ["Billing & Card Details", "OTP Verification", "Thank You"];

  const handleNext = () => {
    setCurrentStep((prevStep) => prevStep + 1);
  };
  const handleBackToHome = () => {
    navigate('/'); // Navigate to the home page
};

  const handleBack = () => {
    setCurrentStep((prevStep) => prevStep - 1);
  };

  return (
    <LoggedInLayout>
      <Box className="payment-page">
        <Box >
          <Typography className="page-heading" variant="h4" fontWeight={500}>

            Payment
          </Typography>


        </Box>
        {/* <Stepper activeStep={currentStep} alternativeLabel>
          {steps.map((label) => (
            <Step key={label}>
              <StepLabel>{label}</StepLabel>
            </Step>
          ))}
        </Stepper> */}
        <Box display={'flex'} gap={6} >
          <Box flex="1" className='container' sx={{ mt: 4 }} >

            {currentStep === 0 && (
              <Box sx={{ padding: '44px' }}>
                <PaymentStepOne
                  formData={formData}

                />
              </Box>

            )}
            {currentStep === 1 && (
              <OTPVerification
                formData={formData}
                setFormData={setFormData}
                handleNext={handleNext}
                handleBack={handleBack}
              />
            )}
            {currentStep === 2 && <Box > <ThankYou handleBackToHome={handleBackToHome} /></Box>}
          </Box>
          {currentStep === 2 && <Box flex="0 0 20%"><img src="/assets/images/background/sucess-person.svg"></img></Box>}
        </Box>

      </Box>
    </LoggedInLayout>
  );
};

export default PaymentPage;
